module.exports = __webpack_public_path__ + "static/media/how-work.a5b36b4f.jpg";